import { ApiService } from "./api-service";
import { ApiEndpoints } from "~/common/api/constants/api-endpoints";
import {
  type AuthTokensResponse,
  authTokensResponseSchema,
  type MeResponse,
  meResponseSchema,
} from "~/common/api/validation/auth-schemas";
import { useCurrentUserStore } from "~/common/global-states/current-user-store";
import { dataStorage } from "~/common/services/data-storage-service";

export class AuthApiService {
  private apiService: ApiService;

  constructor() {
    this.apiService = new ApiService();
  }

  async signIn(payload: { email: string; password: string }) {
    const response = await this.apiService.sendPublicPatch(
      ApiEndpoints.SIGNIN,
      {
        body: payload,
      },
    );
    const tokens = authTokensResponseSchema.parse(response.data);

    dataStorage.putAuthTokens(tokens);

    await useCurrentUserStore.getState().loadUser();

    return tokens;
  }

  async signUp(payload: {
    name: string;
    surname: string;
    companyName: string;
    email: string;
    password: string;
    plan: string;
    planPeriod: string;
  }) {
    const response = await this.apiService.sendPublicPost<AuthTokensResponse>(
      ApiEndpoints.SIGNUP,
      {
        body: payload,
      },
    );
    const tokens = authTokensResponseSchema.parse(response.data);

    dataStorage.putAuthTokens(tokens);

    await useCurrentUserStore.getState().loadUser();

    return tokens;
  }

  async getMe(): Promise<MeResponse> {
    const response = await this.apiService.sendGet<MeResponse>(ApiEndpoints.ME);

    const userData = meResponseSchema.parse(response.data);

    return userData;
  }

  signOut() {
    dataStorage.clearAuthTokens();
  }
}

export const authApiService = new AuthApiService();
